import { AxiosRequestConfig } from "axios";
import { LocalStorageItems } from "../constants";
import { getLocalStorageItem } from "../utils/localStorage";
import axiosInstance from "./axoisInstance.V2";

const baseUrl = process.env.REACT_APP_BASE_URL;
export const baseURL_V2 = "/auth/v2"

export interface ApiResponse<T> {
    data: T;
}
export interface ApiError {
    error: string;
}
export interface AxiosPostOptions {
    headers?: Record<string, string>;
}

export const axiosGet = async (
    url: string,
    options?: AxiosRequestConfig
) => {
    try {
        const mainUrl = `${baseUrl}${url}`;

        // Set default headers
        const defaultHeaders = {
            authorization: getLocalStorageItem(LocalStorageItems.TOKEN),
        };

        // Merge with any additional headers from options
        const headers = options?.headers ? { ...defaultHeaders, ...options.headers } : defaultHeaders;

        const response = await axiosInstance.get(mainUrl, {
            ...options,
            headers,
        });

        return response.data;
    } catch (error) {
        throw error;
    }
};

export const axiosPost = async (
    url: string,
    payload?: Record<string, any>,
    options?: AxiosPostOptions
) => {
    try {
        const mainUrl = `${baseUrl}${url}`;

        // Set default headers
        const defaultHeaders = {
            authorization: getLocalStorageItem(LocalStorageItems.TOKEN),
        };

        const headers = options?.headers ? { ...defaultHeaders, ...options.headers } : defaultHeaders;

        const response = await axiosInstance.post(mainUrl, payload, { headers });
        return response.data;
    } catch (error) {
        throw error;
    }
};

export const axiosPut = async (
    url: string,
    payload: FormData | Record<string, any>
) => {
    try {
        const mainUrl = `${baseUrl}${url}`;
        const response = await axiosInstance.put(mainUrl, payload, {
            headers: {
                authorization: getLocalStorageItem(LocalStorageItems.TOKEN),
            },
        });
        return response.data;
    } catch (error) {
        throw error;
    }
};

export const axiosDelete = async (url: string) => {
    try {
        const mainUrl = `${baseUrl}${url}`;
        const response = await axiosInstance.delete(mainUrl, {
            headers: {
                authorization: getLocalStorageItem(LocalStorageItems.TOKEN),
            },
        });
        return response.data;
    } catch (error) {
        throw error;
    }
};

export const axiosPatch = async (
    url: string,
    payload?: Record<string, any> | FormData,  // Allow FormData or plain object
    options?: AxiosPostOptions
) => {
    try {
        const mainUrl = `${baseUrl}${url}`;

        const defaultHeaders = {
            authorization: getLocalStorageItem(LocalStorageItems.TOKEN),
        };

        const headers = options?.headers
            ? { ...defaultHeaders, ...options.headers }
            : defaultHeaders;

        const response = await axiosInstance.patch(mainUrl, payload, {
            headers,
        });

        return response.data;
    } catch (error) {
        throw error;
    }
};

export const axiosPostFormData = <T = any>(url: string, data?: any, config = {}) =>
    axiosInstance.post(url, data, {
        headers: { 'Content-Type': 'multipart/form-data' },
        ...config,
    });